import { hasFormationRoles } from "@ds/modules/settings/projects/utils/formation-roles";

/** Stand-in ID of the player being added, which has none until it's saved */
export const NEW_PLAYER_ID = 0;

/** Role assignments and players of the experience with the player being added among them */
export const withNewPlayer = (experience?: Experience, formation?: ExperienceDeviceFormation) => ({
  devices: {
    ...experience?.formation?.devices,
    ...(formation && { [NEW_PLAYER_ID]: formation }),
  } as ExperienceDeviceFormationMap,
  playerIds: [...(experience?.device_ids || []), NEW_PLAYER_ID],
});

/** Form path of the new player's role, or of its value of one of the role's fields */
export const getNewPlayerRoleFieldPath = (field: string) =>
  field === "role" ? "formation.role" : `formation.properties.${field}.value`;

/** Whether the add player wizard asks for the new player's role: it joins an experience whose players have roles */
export const hasRoleStep = (roles: FormationRoleMap, experience?: Experience | null) =>
  !!experience && hasFormationRoles(roles);
